import {
    registerApplication,
    start,
} from "single-spa";
registerApplication(
    "support",
    () => import("support_ui"),
    (location) => location.pathname.startsWith("/")
);
start();
